import { createSpinner as create, hideSpinner as hide, showSpinner as show } from '@syncfusion/ej2-popups';

const CONTAINER_ID = 'content';

document.addEventListener('DOMContentLoaded', () => {
  create({
    target: document.getElementById(CONTAINER_ID) as HTMLElement,
  });
});

export const hideSpinner = () => hide(document.getElementById(CONTAINER_ID) as HTMLElement);

export const showSpinner = () => show(document.getElementById(CONTAINER_ID) as HTMLElement);
